import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const StyledButton = styled(Button)(({ theme, height, width }) => ({
  borderRadius: "1.5rem",
  width: width,
  height: height,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));
